<template>
    <div v-if="isLoading" class="col-12">
        <!-- begin loader -->
        <beat-loader-component v-if="isLoading" :isLoading="isLoading"></beat-loader-component>
        <!-- end loader -->
    </div>
    <form v-else class="row" @submit.prevent="submitTransactions">
        <div class="col-md-12 text-center">
            <errors v-if="errors_msg?.message">
                {{ errors_msg.message }}
            </errors>
        </div>
        <loan-transaction-form :form="form" :add_or_edit="false"></loan-transaction-form>
        <hr class="mt-4" />
        <div class="col-12 text-end">
            <button type="submit" :disabled="isSaving" class="btn akkurate-green-btn text-white btn-size my-2 me-3">
                <span class="small">
                    <font-awesome-icon class="me-2" :icon="['fas', 'save']" />Update
                </span>
            </button>
        </div>
    </form>
</template>
<script>
import Multiselect from "vue-multiselect";
import ApiService from "@/core/services/api.service";
import LoanTransactionForm from "./LoanTransactionForm.vue";

export default {
    components: {
        Multiselect,
        LoanTransactionForm
    },
    data() {
        return {
            isLoading: false,
            errors_msg: {},
            coa_subhead: {},
            isSaving: false,
            form: {
                principal_paid: "",
                interest_paid: "",
                narration: "",
                trans_date:"",
            }
        }
    },
    props: {
        trans_data: {
            required: true
        },
    },
     mounted() {
         this.form = {
                principal: this.trans_data.principal,
                interest: this.trans_data.interest,
                narration: this.trans_data.narration,
                transaction_mode: this.trans_data.transaction_mode,
                transaction_type: this.trans_data.transaction_type,
                principal_balance: this.trans_data.principal_balance,
                interest_balance: this.trans_data.interest_balance,
                trans_date: this.trans_data.trans_date
            }

    },
    
    methods: {
        submitTransactions() {
            this.isSaving = true;
            let form = {
                'principal': this.form?.principal,
                'interest': this.form?.interest,
                'narration': this.form?.narration,
                'principal_balance':this.form?.principal_balance,
                'interest_balance':this.form?.interest_balance,
                'trans_date': this.form?.trans_date
            }
            ApiService.put("/loans/transactions/" + this.trans_data.id + '/update', form)
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.save = "Save";
                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    this.errors_msg = {};
                    this.$emit('savedEdit')
                })
                .catch((error) => {
                    this.isSaving = false;
                    this.$Progress.fail();
                    this.save = "Save";
                    if (error.response.data) {
                        // Clear previous errors
                        this.errors_msg = {};

                        // Set general message
                        this.errors_msg.message = error.response.data.message;
                        // Set field-specific errors if they exist
                        if (error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach(key => {
                                this.errors_msg[key] = error.response.data.errors[key];
                            });
                        }
                    }
                });
        },
    }

}
</script>